import axios from "@app/Security/AxiosAuthentication";
import { AxiosError } from "axios";
import Rollbar from "rollbar";
import AppSettings from "./AppSettings";

export default class RollbarHelper {

    static rollbarInstance: Rollbar;

    static getRollbarInstance = (): Rollbar => {

        if (!RollbarHelper.rollbarInstance) {

            const rollbarConfig = {
                accessToken: AppSettings.getRollbarAccessToken(),
                environment: AppSettings.getRollbarEnvironment()
            };

            const newRollbar = new Rollbar(rollbarConfig);

            RollbarHelper.rollbarInstance = newRollbar;

        }

        return RollbarHelper.rollbarInstance;

    }

    static logRequestError = (error: Error | AxiosError | unknown, title: string): void => {

        const rollbar = RollbarHelper.getRollbarInstance();

        if (axios.isAxiosError(error)) {

            rollbar.error(`${title} - AxiosError`, error);


        } else if (error instanceof Error) {

            // TODO: Optional improvement. User regex match instead.
            if (error?.name && error.name.toLowerCase() === "typeerror" && error.message.toLowerCase().includes("cannot destructure property 'status' of") && error.message.toLowerCase().includes("is undefined.")) {

                // very likely request was cancelled by user or when navigating to another page.
                // don't record anything.
                // the message will look similar to 
                //    Cannot destructure property 'status' of 'e.response' as it is undefined.
                //    Cannot destructure property 'status' of 'error.response' as it is undefined.
                //    Cannot destructure property 'status' of 'e.response' is undefined.

            } else if (error?.name && error.name.toLowerCase() === "typeerror" && error.message.toLowerCase() === "right side of assignment cannot be destructured") {
                // very likely request was cancelled by user or when navigating to another page.
                // don't record anything. Seems to only impact iOS/MacOS using Safari.
                // See https://app.rollbar.com/a/SiteCraftingInc./fix/item/dnda-front-end/157
            } else {

                rollbar.error(`${title} - StockError`, error);

            }

        } else {

            rollbar.error(`${title} - UnknownError`);

        }

    }

    static logRollbarInfo = (data: any, title: string): void => {

        const rollbar = RollbarHelper.getRollbarInstance();

        rollbar.info(title, data);

    }

}
